import { render, staticRenderFns } from "./ViewAttachment.vue?vue&type=template&id=f0f5d004"
import script from "./ViewAttachment.vue?vue&type=script&lang=js"
export * from "./ViewAttachment.vue?vue&type=script&lang=js"
import style0 from "./ViewAttachment.vue?vue&type=style&index=0&id=f0f5d004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports